import { AppDropDownWithSuggestionInput, AppDropDownWithSuggestionProps } from 'uikit/inputs';
import { BuilderFieldError, BuilderFieldErrorProps, ErrorSign } from '../../wrappers/error/builderFieldError.component';
import { BuilderFieldLabel, BuilderFieldLabelProps } from '../../wrappers/label/builderFieldLabel.component';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';

export type AppDropdownFieldProps<T extends DropdownOption> = {
  labelProps: BuilderFieldLabelProps;
  errorProps?: BuilderFieldErrorProps;
} & AppDropDownWithSuggestionProps<T>;

export const AppDropdownField = <T extends DropdownOption>({
  errorProps,
  labelProps,
  disabled,
  ...rest
}: AppDropdownFieldProps<T>) => {
  return (
    <BuilderFieldError {...errorProps}>
      <BuilderFieldLabel disabled={disabled} rightSection={errorProps?.errors ? <ErrorSign /> : <></>} {...labelProps}>
        <AppDropDownWithSuggestionInput<T> disabled={disabled} invalid={!!errorProps?.errors} {...rest} />
      </BuilderFieldLabel>
    </BuilderFieldError>
  );
};
